import { LatLngTuple } from 'leaflet';

export const maxPassengerCount = 5;

export enum RouteKind {
  NORMAL = 'normal',
  FAKE ='fake'
}

export enum SubscriptionKind {
  DAY = 'day',
  WEEK = 'week',
  WEEK_TRIAL = 'week_trial',
  MONTH = 'month',
  MONTH_SUB = 'month_sub',
  TWO_MONTH = 'two_month',
  DAY_CASH_TRIAL = 'day_cash_trial',
  DAY_ONLINE_TRIAL = 'day_online_trial',
  THREE_DAYS_ONLINE_TRIAL = 'three_days_online_trial',
  PREPAYMENT = 'prepayment'
}

export enum TransportationRequestKind {
  TO_WORK = "to_work",
  FROM_WORK = "from_work", 
  ROUND_TRIP = "round_trip",
}

export const routeDirection = { TO: 'to', FROM: 'from' };
export const cityCenterCoords: LatLngTuple = [43.318931, 76.8880775];

export const KASPI_INTEGRATION_VERSION = '1.19.3';
export const KASPI_URL_PREFIX = 'https://kaspi.kz/pay';
